module.exports = __webpack_public_path__ + "img/downloads-xls.6813146a.svg";